module.exports = __webpack_public_path__ + "img/xin_shang_lu_shi_pin_hao.52fbebb2.png";